export default {
  name: "StyleSwitch",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: this.modelValue
    };
  },
  watch: {
    modelValue(newVal) {
      this.checked = newVal;
    }
  }
};